import React from 'react';
import Layout from '../components/Layout';

export default function RefundPolicy() {
  return (
    <Layout>
      <div className="page-banner">
        <h1>Refund Policy</h1>
      </div>
      <div className="main-content">
        <div className="policy-content">
          <h2>Refund Policy</h2>
          <p className="updated">Last Updated: May 21, 2026</p>

          <p>
            Smart Device Assistant provides free informational content. No products or services are sold directly
            on this website, so refunds are not applicable.
          </p>

          <p>
            If you purchase any products through third-party links (e.g., HP store or Amazon), all refunds or
            returns are subject to the seller's policies.
          </p>

          <h3>Third-Party Links Disclaimer:</h3>
          <p>
            Our website may include links to third-party websites. If you interact with any of these third-party
            sites, please do so carefully. We do not control these websites and are{' '}
            <strong>not responsible for their content, actions, or any transactions</strong> you may conduct on them.
          </p>
        </div>
      </div>
    </Layout>
  );
}
